import callAccountsApi from './data-provider'
import { arrayBufferToBase64, normaliseBinaryPayload } from './components/utils'

export const getImageData = async key => {
  let result = await callAccountsApi('files','getImage',{key})

  if (!result || !result.bodyBase64)
  {
    return null
  }

  let buffer = normaliseBinaryPayload(result.bodyBase64)
  let blob = new Blob([buffer], { type: result.contentType })

  return {
    buffer,
    contentType: result.contentType,
    blobUrl: URL.createObjectURL(blob)
  }
}

export const saveImage = async ({ key, body, contentType, oldKey }) => {
  let bodyBase64 = arrayBufferToBase64(body)

  return await callAccountsApi('files','putImage',{
    key,
    bodyBase64,
    contentType,
    oldKey
  })
}

export const deleteImage = async key => {
  return await callAccountsApi('files','deleteImage',{ key })
}
